module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_4-ad704977ecc225ca6bef0633451ad8e1.jpg";